import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Box,
  Typography,
  Paper,
  CardMedia,
  CardContent,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  styled,
  Tooltip,
  FormControlLabel,
  Switch,
  CurrencyRupee,
  Stack,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/FavoriteBorder";
import BathtubIcon from "@mui/icons-material/Bathtub";
// import HotelIcon from "@mui/icons-material/Hotel";
import BedIcon from "@mui/icons-material/Bed";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import NoticeIcon from "@mui/icons-material/CalendarMonth";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { useRef, useState } from "react";
import UnitNumberForm from "../../features/units/components/UnitNumberForm";
import UnitForm from "../../features/units/components/UnitForm";
import dayjs from "dayjs";
import makeFullUrl from "../../utils/cloudinary";
import PriceDisplay from "../PriceDisplay";
import { InfoOutlined } from "@mui/icons-material";
import UnitDetailsDialog from "./UnitDetailsDialog"; // Import the new component

const PropertyItem = styled(Paper)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  transition: "transform 0.3s",
  // "&:hover": {
  //   transform: "translateY(-5px)",
  // },
  borderRadius: "8px",
}));

// Comments styled component for consistent height
const CommentTeaser = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  color: theme.palette.text.secondary,
  display: "-webkit-box",
  WebkitLineClamp: 1, // Strict 1-line limit
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  minHeight: "1.5em", // Reserves space even if empty to keep cards aligned
  fontSize: "0.875rem",
}));

const UnitCard = ({
  unit,
  property,
  unitTypes = { entities: {} },
  onToggle,
  onEdit,
  onDelete,
  // onStatusUpdating,
}) => {
  // Destructure out entities (with a safe default)
  const { entities } = unitTypes || {};
  const [selectedUnit, setSelectedUnit] = useState(null);
  //   const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [detailsOpen, setDetailsOpen] = useState(false); // New state for Details Dialog

  // Custom arrow components
  const SampleNextArrow = (props) => {
    const { onClick } = props;
    return (
      <IconButton
        onClick={onClick}
        sx={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
          color: "white",
          bgcolor: "rgba(0,0,0,0.5)",
          "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
        }}
      >
        <ChevronRight fontSize="large" />
      </IconButton>
    );
  };

  const SamplePrevArrow = (props) => {
    const { onClick } = props;
    return (
      <IconButton
        onClick={onClick}
        sx={{
          position: "absolute",
          left: 8,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
          color: "white",
          bgcolor: "rgba(0,0,0,0.5)",
          "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
        }}
      >
        <ChevronLeft fontSize="large" />
      </IconButton>
    );
  };

  const dialogSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (current, next) => setActiveImageIndex(next),
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <ul style={{ margin: 0, padding: 0 }}>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor:
            i === activeImageIndex ? "#fff" : "rgba(255,255,255,0.5)",
          margin: "0 4px",
          cursor: "pointer",
        }}
      />
    ),
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    beforeChange: (current, next) => setActiveImageIndex(next),
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <ul style={{ margin: 0, padding: 0 }}>{dots}</ul>
      </div>
    ),
  };

  const formattedPrice = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: unit.price % 1 !== 0 ? 2 : 0, // Ensures two decimal places if available
    maximumFractionDigits: 2, // Limits to two decimal places
  }).format(unit.price);
  // .replace("₹", "₹ ");

  // List of Payment Fequency for dropdown menu
  const paymentFrequencyArray = [
    { key: "monthly", value: "Monthly" },
    { key: "yearly", value: "Yearly" },
    { key: "daily", value: "Daily" },
  ];

  // List of Bedrooms for dropdown menu
  const bedroomsArray = [
    { key: "studio", value: "Studio" },
    { key: "1", value: "1" },
    { key: "2", value: "2" },
    { key: "3", value: "3" },
    { key: "4", value: "4" },
    { key: "5", value: "5" },
    { key: "5+", value: "5+" },
  ];

  const bathroomTypeArray = [
    { key: "attached", value: "Attached" },
    { key: "common", value: "Common" },
    // { key: "shared", value: "Shared" },
    { key: "2", value: "2" },
    { key: "3", value: "3" },
    { key: "4", value: "4" },
    { key: "5", value: "5" },
    { key: "5+", value: "5+" },
  ];

  // Helper function to get the display value from a key
  const getDisplayValue = (key, options) => {
    const option = options.find((opt) => opt.key === key);
    return option ? option.value : key; // Fallback to key if no match is found
  };

  const getOrderedImages = (unit) => {
    // Safely extract main image path
    const mainImagePath = unit.mainImage?.filePath
      ? // ? `${process.env.REACT_APP_SERVER_URL}/${unit.mainImage.filePath}`
        makeFullUrl(unit.mainImage.filePath, unit.mainImage.fileType)
      : // : unit.mainImage.url;
        URL.createObjectURL(unit.mainImage.file);

    // Safely extract image paths with error filtering
    const imagePaths = (unit.images || []).flatMap((image) =>
      image?.filePath
        ? // ? [`${process.env.REACT_APP_SERVER_URL}/${image.filePath}`]
          [makeFullUrl(image.filePath, image.fileType)]
        : // : [image.file]
          [URL.createObjectURL(image.file)]
    );

    // Merge with main image first (if exists)
    return mainImagePath ? [mainImagePath, ...imagePaths] : imagePaths;
  };

  const getUnitTypeName = () => {
    // const entity = entities[unit.unitType];
    // return entity?.name ?? "";
    return unit?.unitType?.name;
  };

  // Local state for editing
  // const [editData, setEditData] = useState(unit);
  // const [isEditing, setIsEditing] = useState(false);

  // Handle status toggle
  const handleStatusToggle = () => {
    onToggle();
  };

  // // Handle edit button click
  // const handleEditClick = () => {
  //   setIsEditing(true);
  // };

  // State for managing the edit dialog
  const [editDialogOpen, setEditDialogOpen] = useState(false);

  // Ref to access the UnitForm methods
  const unitFormRef = useRef(null);
  const unitNumberFormRef = useRef(null);

  // Open the edit dialog for a specific unit
  const handleEditUnit = (unit) => {
    setSelectedUnit(unit);
    setEditDialogOpen(true);
  };

  // Close the edit dialog
  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setSelectedUnit(null);
  };

  // // The list of units generated from the template
  // const [units, setUnits] = useState([]);

  // Save changes to a unit
  const handleSaveUnit = () => {
    if (unitFormRef.current && unitNumberFormRef.current) {
      const isValid = unitFormRef.current.validateUserInput(); // Validate the form
      const isUnitNumberValid = unitNumberFormRef.current.validateUserInput();

      if (isValid && isUnitNumberValid) {
        const unitFormData = unitFormRef.current.getFormData();
        const unitNumberData = unitNumberFormRef.current.getFormData();

        // Merge the updated data
        const updatedUnit = {
          ...selectedUnit,
          ...unitFormData,
          ...unitNumberData,

          prefix: unitNumberData.unitPrefix || selectedUnit.prefix,
          number: unitNumberData.unitNumber || selectedUnit.number,
          // mainImage: unitFormData.unitMainImage || selectedUnit.mainImage,
          // images: unitFormData.unitImages || selectedUnit.images,
          mainImage: {
            ...unitFormData.unitMainImage,
            // Preserve preview URL if exists
            url: unitFormData.unitMainImage?.url
              ? unitFormData.unitMainImage.url
              : URL.createObjectURL(unitFormData.unitMainImage?.file),
          },
          images: (unitFormData.unitImages || []).map((img) => ({
            ...img,
            url: img?.url ? img.url : URL.createObjectURL(img.file),
          })),
          availabilityDates: [
            {
              startDate: unitFormData.startDate
                ? unitFormData.startDate.toISOString()
                : null,
              endDate: unitFormData.endDate
                ? unitFormData.endDate.toISOString()
                : null,
            },
          ],
        };

        // Remove redundant fields
        delete updatedUnit.unitPrefix;
        delete updatedUnit.unitNumber;
        // delete updatedUnit.status;
        delete updatedUnit.unitMainImage;
        delete updatedUnit.unitImages;
        delete updatedUnit.startDate;
        delete updatedUnit.endDate;

        onEdit(updatedUnit); // Send updated data to parent
        handleCloseEditDialog(); // Close the dialog
      } else {
        console.error("Validation failed. Please fix the errors.");
      }
    }
  };

  // const [units, setUnits] = useState(
  //   // unit.status === "Available" ? true : false
  //   // property.units.map((unit) => ({
  //   units.map((unit) => ({
  //     available: unit.available !== undefined ? unit.available : false,
  //     ...unit,
  //   }))
  // );

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleDeleteUnit = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  return (
    <>
      <PropertyItem elevation={3}>
        {/* Image Slider */}
        <Box
          sx={{
            position: "relative",
            "&:hover .slick-arrow": {
              opacity: 1,
            },
          }}
          onClick={() => {
            setSelectedUnit(unit);
            setIsGalleryOpen(true);
          }}
        >
          <Slider {...sliderSettings}>
            {getOrderedImages(unit).map((img, idx) => (
              <div key={idx}>
                <CardMedia
                  component="img"
                  image={img}
                  alt={`Unit ${idx + 1}`}
                  sx={{
                    height: 250,
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                />
              </div>
            ))}
          </Slider>

          {/* Wishlist Button */}
          {/* <IconButton
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    color: "white",
                    // color: unit.isWishlisted ? "red" : "white",
                    // bgcolor: "rgba(0,0,0,0.3)",
                    // "&:hover": {
                    //   bgcolor: "rgba(0,0,0,0.5)",
                    // },
                  }}
                  // onClick={() => {
                  //   setSelectedUnit(unit);
                  //   setIsGalleryOpen(true);
                  // }}
                  onClick={() => handleToggleWishlist(unit.id)}
                >
                  {unit.isWishlisted ? (
                    <FavoriteIcon />
                  ) : (
                    <FavoriteBorderIcon />
                  )}
                </IconButton> */}

          {/* Fullscreen Button */}
          <IconButton
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "white",
              bgcolor: "rgba(0,0,0,0.3)",
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.5)",
              },
            }}
            onClick={() => {
              setSelectedUnit(unit);
              setIsGalleryOpen(true);
            }}
          >
            <FullscreenIcon />
          </IconButton>
        </Box>

        {/* Unit Details */}
        {/* <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" component="h3">
              {unit.prefix}
              {unit.number}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography variant="body1">{getUnitTypeName()}</Typography>
          </Box> */}

        <CardContent
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          {/* Header: Unit # and Type */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Box
              sx={{
                //   display: "flex",
                //   justifyContent: "space-between",
                mb: 1,
              }}
            >
              <Typography variant="h6" fontWeight="800" lineHeight={1.1}>
                {unit.prefix} {unit.number}
              </Typography>
              <Typography variant="body1">{getUnitTypeName()}</Typography>
            </Box>
            {/* <Chip
              label={unit.status}
              color={unit.status === "Available" ? "success" : "default"}
              size="small"
              variant="filled"
            /> */}
          </Box>

          {/* <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <BedIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2">
                {getDisplayValue(unit.bedrooms, bedroomsArray)}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <BathtubIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2">
                {getDisplayValue(unit.bathroomType, bathroomTypeArray)}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <NoticeIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2">
                {unit.noticePeriodDays} days
              </Typography>
            </Box> */}
          {/* <Box sx={{ display: "flex", alignItems: "center" }}>
              <SquareFootIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2">
                {unit.size} sqft */}
          {/* <sup>2</sup> */}
          {/* <Typography
                  component="span"
                  variant="caption"
                  sx={{ verticalAlign: "super", fontSize: "0.6rem" }}
                >
                  2
                </Typography> */}
          {/* </Typography>
            </Box> */}
          {/* </Box> */}

          {/* Key Specs Row (Icons) */}
          <Stack
            direction="row"
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            <Box display="flex" alignItems="center" gap={0.5}>
              <BedIcon fontSize="small" />
              <Typography variant="body2">
                {unit.unitType.occupancyCount
                  ? unit.unitType.occupancyCount
                  : getDisplayValue(unit.bedrooms, bedroomsArray)}
                {/* BHK */}
              </Typography>
            </Box>
            {/* Tooltip can be used to display long text Shared: "Shared betwen 2-3 rooms" */}
            {/* <Tooltip title={unit.bathroomType} arrow> */}
            <Box display="flex" alignItems="center" gap={0.5}>
              <BathtubIcon fontSize="small" />
              <Typography variant="body2">
                {getDisplayValue(unit.bathroomType, bathroomTypeArray)}
              </Typography>
            </Box>
            {/* </Tooltip> */}
            <Box display="flex" alignItems="center" gap={0.5}>
              <SquareFootIcon fontSize="small" />
              <Typography variant="body2">{unit.size} sqft</Typography>
            </Box>
          </Stack>

          <Divider sx={{ borderStyle: "dashed" }} />

          {/* Pricing Row - The most important part */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography
                variant="caption"
                display="block"
                color="text.secondary"
              >
                Monthly Rent
              </Typography>
              <PriceDisplay
                unitPrice={unit.price}
                sx={{ fontWeight: "bold", fontSize: 20 }}
              />
            </Box>
            <Box textAlign="right">
              <Typography
                variant="caption"
                display="block"
                color="text.secondary"
              >
                Deposit
              </Typography>
              <PriceDisplay
                unitPrice={unit.securityDeposit}
                sx={{
                  fontWeight: "bold",
                  fontSize: 20,
                  color: "text.secondary",
                }}
              />
            </Box>
          </Box>
          <CommentTeaser variant="body2">
            {unit.comments || (
              <span style={{ color: "rgba(0,0,0,0.45)", fontStyle: "italic" }}>
                No description provided.
              </span>
            )}
          </CommentTeaser>
        </CardContent>

        {/* 3. Actions Footer - Stick to bottom */}
        <Box p={2} pt={0} display="flex" gap={1}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<InfoOutlined />}
            onClick={() => setDetailsOpen(true)}
          >
            Details
          </Button>

          {/* Edit Actions Group */}
          {/* <Box display="flex" gap={0.5}>
            <IconButton
              size="small"
              onClick={() => handleEditUnit(unit)}
              sx={{ border: "1px solid #eee" }}
            >
              <EditIcon fontSize="small" color="primary" />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => setIsDeleteDialogOpen(true)}
              sx={{ border: "1px solid #eee" }}
            >
              <DeleteIcon fontSize="small" color="error" />
            </IconButton>
          </Box> */}
        </Box>
      </PropertyItem>

      {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography variant="h6" color="inherit"> */}
      {/* {formattedPrice} */}
      {/* <PriceDisplay unitPrice={unit.price} /> */}
      {/* {unit.paymentFrequency} */}
      {/* </Typography> */}
      {/* <Typography variant="caption" color="text.secondary">
                      {unit.priceTerms}
                    </Typography> */}
      {/* </Box> */}
      {/* <Typography
                    variant="subtitle2"
                    sx={{ color: "grey", ml: 1, mt: 0.4 }}
                    color="text.secondary"
                  >
                    {unit.paymentFrequency}
                  </Typography> */}

      {/* <Chip
              //   label={getDisplayValue("monthly", paymentFrequencyArray)}
            //   label="Monthly"
            //   color="inherit"
            //   sx={{ ml: 1 }}
              // size="small"
              // sx={{ backgroundColor: "black", color: "white" }}
            /> */}
      {/* <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setSelectedUnit(unit);
                      setIsBookingOpen(true);
                    }}
                  >
                    Book Now
                  </Button> */}
      {/* </Box> */}

      {/* {unit.comments && (
        <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
          {unit.comments}
        </Typography>
      )} */}
      {/* {property.nftType !== MONO_NFT_TYPE && (
            <hr
              style={{
                // width: "400px", // Ensure the <hr> spans the full width
                border: "none", // Remove default border
                borderTop: "1px solid #ccc", // Add a custom horizontal line
                margin: "16px 0", // Add margin for spacing
              }}
            />
          )} */}
      {/* {property.nftType !== MONO_NFT_TYPE && (
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Tooltip
                title={
                  unit.status === "Available"
                    ? // ? "This unit is available for rent"
                      // : "This unit is currently occupied"
                      "This unit will be displayed to public"
                    : "This unit will not be displayed to public"
                }
                arrow
              >
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={unit.status === "Available"}
                      onChange={handleStatusToggle}
                      sx={{
                        "& .MuiSwitch-track,.MuiSwitch-thumb": {
                          backgroundColor:
                            unit.status === "Available"
                              ? "#4caf50 !important"
                              : "#f44336",
                        },
                      }}
                      // disabled={onStatusUpdating}
                      disabled={unit.isUpdating}
                    />
                  }
                  label={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        // variant="body2"
                        sx={{
                          //   color: unit.available ? "#4caf50" : "#f44336",
                          //   fontWeight: "bold",
                          width: "75px",
                        }}
                      >
                        {unit.status === "Available" ? "Available" : "Occupied"}
                      </Typography> */}
      {/* <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          bgcolor: unit.available ? "#4caf50" : "#f44336",
                          ml: 1,
                        }}
                      /> */}
      {/* </Box>
                  }
                  labelPlacement="start"
                  sx={{ m: 0 }}
                />
              </Tooltip>
              <Box>
                <IconButton onClick={() => handleEditUnit(unit)} color="info">
                  <EditIcon />
                </IconButton>
                <IconButton
                  onClick={() => setIsDeleteDialogOpen(true)}
                  sx={{ pr: 0, m: -0.5 }}
                  color="error"
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          )} */}
      {/* </CardContent>
      </PropertyItem> */}

      {/* --- DIALOGS --- */}

      {/* 1. The NEW Consolidated Details Dialog */}
      <UnitDetailsDialog
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        unit={unit}
        property={property}
        // key={unit.id}
      />

      {/* 2. Your Existing Gallery Dialog (Keep as is) */}
      {/* <Dialog open={isGalleryOpen} ... > ... </Dialog> */}

      {/* 3. Your Existing Edit Dialog (Keep as is) */}
      {/* <Dialog open={editDialogOpen} ... > ... </Dialog> */}

      {/* 4. Your Existing Delete Dialog (Keep as is) */}
      {/* <Dialog open={isDeleteDialogOpen} ... > ... </Dialog> */}
      {/* </>
  );
}; */}

      {/* 1. Image Gallery Dialog */}
      <Dialog
        open={isGalleryOpen}
        onClose={() => setIsGalleryOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          {/* {property.nftType === MONO_NFT_TYPE
            ? getUnitTypeName()
            : selectedUnit && selectedUnit?.prefix + selectedUnit?.number}{" "} */}
          {getUnitTypeName()} Gallery
          <IconButton
            sx={{ position: "absolute", right: 8, top: 8 }}
            onClick={() => setIsGalleryOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Slider {...dialogSliderSettings} initialSlide={activeImageIndex}>
            {selectedUnit &&
              getOrderedImages(selectedUnit).map((img, idx) => (
                <div key={idx}>
                  <CardMedia
                    component="img"
                    image={img}
                    alt={`Unit ${idx + 1}`}
                    sx={{ maxHeight: "70vh", objectFit: "contain" }}
                  />
                </div>
              ))}
          </Slider>
        </DialogContent>
      </Dialog>

      {/* 2. Edit Dialog */}
      <Dialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        maxWidth="md"
        fullWidth // Ensure the dialog uses the full width
        // scroll="paper" // Make the content scrollable
      >
        {/* Dialog Title */}
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e0e0e0",
            // backgroundColor: "#f5f5f5"
          }}
        >
          Edit: {selectedUnit && selectedUnit?.prefix + selectedUnit?.number}
        </DialogTitle>

        {/* Dialog Content */}
        <DialogContent dividers sx={{ padding: 3 }}>
          {selectedUnit && (
            <Box
              // component="form"
              // onSubmit={handleSubmit}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 3,
              }}
            >
              <UnitNumberForm
                ref={unitNumberFormRef} // Pass the ref to the form
                onDataChange={(data) => setSelectedUnit(data)}
                initialData={{
                  ...selectedUnit,
                  unitPrefix: selectedUnit.prefix,
                  unitNumber: selectedUnit.number,
                }}
              />
              <UnitForm
                ref={unitFormRef} // Pass the ref to the form
                unitTypes={unitTypes}
                onDataChange={(data) => setSelectedUnit(data)}
                // parent={"Property"}
                initialData={{
                  ...selectedUnit,
                  startDate:
                    selectedUnit.availabilityDates?.length > 0 &&
                    !!selectedUnit.availabilityDates[0]?.startDate
                      ? dayjs(selectedUnit.availabilityDates[0].startDate)
                      : null,
                  endDate:
                    selectedUnit.availabilityDates?.length > 0 &&
                    !!selectedUnit.availabilityDates[0]?.endDate
                      ? dayjs(selectedUnit.availabilityDates[0].endDate)
                      : null,
                  unitMainImage: selectedUnit.mainImage,
                  unitImages: selectedUnit.images,
                }}
              />
            </Box>
          )}
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions
          sx={{
            borderTop: "1px solid #e0e0e0",
            backgroundColor: "#f5f5f5",
            padding: 2,
          }}
        >
          <Button onClick={handleCloseEditDialog} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={() => handleSaveUnit(selectedUnit)}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* 3. Delete Confirmation Dialog */}
      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
      >
        <DialogTitle>
          Delete Unit
          <IconButton
            sx={{ position: "absolute", right: 8, top: 8 }}
            onClick={() => setIsDeleteDialogOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this unit?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={() => setIsDeleteDialogOpen(false)}
            color="primary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleDeleteUnit()}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UnitCard;
